import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A visit to the dentist",
  "description": "",
  "published": "2012-01-25T00:00:00.000Z",
  "redirect_from": ["/blog/a-visit-to-the-dentist/swizec/3528"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`It took me six months to work up the courage to make an appointment for the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Dentist",
        "title": "Dentist"
      }}>{`dentist`}</a>{`. After some `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/going-to-the-dentist-is-like-trying-out-a-new-opensource-project/swizec/2881",
        "title": "Going to the dentist is like trying out a new opensource project"
      }}>{`initial confusion`}</a>{`I finally managed to bump into someone and magically make an appointment before I could realize what was going on.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/01/300px-Medieval_dentistry3.jpg",
        "alt": "An image from 1300s (A.D.) England depicting a...",
        "title": "An image from 1300s (A.D.) England depicting a..."
      }}></img></p>
    <p>{`I was told to come back in a month.`}</p>
    <p><em parentName="p">{`Today.`}</em></p>
    <p>{`The experience taught me two things:`}</p>
    <ol>
      <li parentName="ol">{`My teeth are made of magic`}</li>
      <li parentName="ol">{`I am far more afraid of dentists than I had thought`}</li>
    </ol>
    <p>{`Ever heard of the expression `}<em parentName="p">{`white with fear`}</em>{`? Turns out it can actually happen. Just like Tom turns completely white when a train is rushing towards him, so too my face turned white when I was sitting in that damn chair. Nearly fainted too.`}</p>
    <p>{`I never did like dentists much - seven years since my last appointment after all - but to `}<em parentName="p">{`nearly faint`}</em>{` from fear? Nausea, tunnel vision, white face; the whole shebang! Didn't even feel that bad, but you know shit's going down when the dentist removes your glasses "just in case" and puts a wet rag on your forehead.`}</p>
    <p>{`Lucky for me, I have magical teeth and the tally from all the years of neglect is just:`}</p>
    <ul>
      <li parentName="ul">{`one broken filling`}</li>
      <li parentName="ul">{`three `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Wisdom_tooth",
          "title": "Wisdom tooth"
        }}>{`wisdom teeth`}</a>{` with some caries`}</li>
      <li parentName="ul">{`inflamed gums`}</li>
    </ul>
    <p>{`None of that `}<em parentName="p">{`OMG my wisdom teeth are breaking my head and trying to destroy everything!!!`}</em>{` I honestly expected much worse, but hey, I'll take the deal ;)`}</p>
    <p>{`It also turns out I suck at keeping my mouth open and will be having much fun the next time I visit ... something about working on the back teeth and not being able to get the drill completely vertical and maybe not even being able to work on them ...`}</p>
    <p>{`Now my face feels funny from the injection, the `}<em parentName="p">{`optional`}</em>{` injection. Can't imagine the amounts of pain there would be had I not told them that yes, yes I do want that injection thing. You did notice I almost fainted when you were just `}<em parentName="p">{`cleaning`}</em>{` my teeth right? WHY ARE YOU ASKING ME THIS!?`}</p>
    <p>{`Those things take a while to really kick in. She was almost done drilling before I stopped feeling everything and even then just the air blowing over my teeth hurt like `}<em parentName="p">{`hell.`}</em>{` Not to even mention the disinfectant.`}</p>
    <p>{`Another appointment in a few weeks and then I guess I'm good to go for another seven years. Right?`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.bellasugar.com/Crest-Weekly-Intensive-Cleaning-Toothpaste-Review-2627319"
        }}>{`No Dentist Appointment? No Problem.`}</a>{` (bellasugar.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://uclaislamicstudies.com/2012/01/17/wisdom-teeth-extraction-complications/"
        }}>{`Wisdom Teeth Extraction Complications`}</a>{` (uclaislamicstudies.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://ask.metafilter.com/204770/Should-my-sevenyearold-sons-dentist-knock-him-out"
        }}>{`Should my seven-year-old son's dentist knock him out?`}</a>{` (ask.metafilter.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://kilnviews.wordpress.com/2012/01/24/hiding-from-the-hygienist/"
        }}>{`Hiding from the hygienist`}</a>{` (kilnviews.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://oppathfinder.com/2012/01/18/military-dentists/"
        }}>{`Military Dentists`}</a>{` (oppathfinder.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://ask.metafilter.com/205838/weird-feelings-in-my-teeth"
        }}>{`weird feelings in my teeth!`}</a>{` (ask.metafilter.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=37822309-8d88-4a79-bbd3-f8614d613f94",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      